// entry file for Rollup for the UMD build \w Emojis
export * from './components';
export * from './context';
export * from './i18n';
// todo: distribute utils into separate files
export * from './utils';
export { getChannel } from './utils/getChannel';
export * from './components/Emojis';
